module.exports = __webpack_public_path__ + "static/media/FIVE.4b3d9c5e.png";